/**
 * @fileoverview gRPC-Web generated client stub for cloud
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var event_pb = require('./event_pb.js')
const proto = {};
proto.cloud = require('./service_live_subscriber_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceLiveSubscribeClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceLiveSubscribePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.LiveProjectStreamRequest,
 *   !proto.cloud.LiveProjectStreamResponse>}
 */
const methodDescriptor_ServiceLiveSubscribe_LiveProjectStream = new grpc.web.MethodDescriptor(
  '/cloud.ServiceLiveSubscribe/LiveProjectStream',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.cloud.LiveProjectStreamRequest,
  proto.cloud.LiveProjectStreamResponse,
  /**
   * @param {!proto.cloud.LiveProjectStreamRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.LiveProjectStreamResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.LiveProjectStreamRequest,
 *   !proto.cloud.LiveProjectStreamResponse>}
 */
const methodInfo_ServiceLiveSubscribe_LiveProjectStream = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.LiveProjectStreamResponse,
  /**
   * @param {!proto.cloud.LiveProjectStreamRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.LiveProjectStreamResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.LiveProjectStreamRequest} request The request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.LiveProjectStreamResponse>}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceLiveSubscribeClient.prototype.liveProjectStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/cloud.ServiceLiveSubscribe/LiveProjectStream',
      request,
      metadata || {},
      methodDescriptor_ServiceLiveSubscribe_LiveProjectStream);
};


/**
 * @param {!proto.cloud.LiveProjectStreamRequest} request The request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.LiveProjectStreamResponse>}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceLiveSubscribePromiseClient.prototype.liveProjectStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/cloud.ServiceLiveSubscribe/LiveProjectStream',
      request,
      metadata || {},
      methodDescriptor_ServiceLiveSubscribe_LiveProjectStream);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.LiveUserStreamRequest,
 *   !proto.cloud.LiveUserStreamResponse>}
 */
const methodDescriptor_ServiceLiveSubscribe_LiveUserStream = new grpc.web.MethodDescriptor(
  '/cloud.ServiceLiveSubscribe/LiveUserStream',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.cloud.LiveUserStreamRequest,
  proto.cloud.LiveUserStreamResponse,
  /**
   * @param {!proto.cloud.LiveUserStreamRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.LiveUserStreamResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.LiveUserStreamRequest,
 *   !proto.cloud.LiveUserStreamResponse>}
 */
const methodInfo_ServiceLiveSubscribe_LiveUserStream = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.LiveUserStreamResponse,
  /**
   * @param {!proto.cloud.LiveUserStreamRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.LiveUserStreamResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.LiveUserStreamRequest} request The request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.LiveUserStreamResponse>}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceLiveSubscribeClient.prototype.liveUserStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/cloud.ServiceLiveSubscribe/LiveUserStream',
      request,
      metadata || {},
      methodDescriptor_ServiceLiveSubscribe_LiveUserStream);
};


/**
 * @param {!proto.cloud.LiveUserStreamRequest} request The request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.LiveUserStreamResponse>}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceLiveSubscribePromiseClient.prototype.liveUserStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/cloud.ServiceLiveSubscribe/LiveUserStream',
      request,
      metadata || {},
      methodDescriptor_ServiceLiveSubscribe_LiveUserStream);
};


module.exports = proto.cloud;

